import Vue from "vue";
import VueRouter from "vue-router";
let moment = require("jalali-moment");
// Routes
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from "@/auth/utils";

import panel from "./routes/panel";
import store from "@/store";
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: "/",
  stringifyQuery(query) {
    var result = require("qs").stringify(query, {
      encode: false,
      arrayFormat: "indices",
      skipNulls: true,
      sort: (a, b) => a.localeCompare(b),
    });
    return result ? "?" + result : "";
  },
  parseQuery(query) {
    var result = require("qs").parse(query);
    if (result.attributes) {
      var tempAttr = require("qs").parse(result.attributes);
      var attributes = [];
      Object.keys(tempAttr).forEach((key) => {
        attributes["attributes[" + key + "]"] = tempAttr[key];
      });
      result.attributes = undefined;
      result = { ...result, ...attributes };
    }
    return result;
  },
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
    },
    ...panel,
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

router.beforeEach((to, _, next) => {
  let accountType =
    store.state.userData && store.state.userData.type
      ? store.state.userData.type
      : getUserData() && getUserData().type
      ? getUserData().type
      : "user";
  let redirectName =
    accountType == "user" || accountType == "admin"
      ? "user-dashboard"
      : "partner-dashboard";
  const accountTypeCap =
    accountType.charAt(0).toUpperCase() + accountType.slice(1);
  const isLoggedIn = isUserLoggedIn();
  let userData = getUserData();
  let userStatus = {
    hasPlan: userData && userData.plan && Object.keys(userData.plan).length > 0,
    verify: userData && userData.verified,
    hasDocument:
      userData &&
      userData.documents &&
      Object.keys(userData.documents).length > 0,
  };
  try {
    if (to.meta.notNeedLogin) {
      return next();
    }

    if (isLoggedIn) {
      if (accountType === "partner") {
        if (userData.status == "ACCEPTED" || userData.status == "ACTIVE") {
          if (userStatus.verify) {
            if (userStatus.hasPlan) {
              return to.meta.onlyPartner &&
                !to.fullPath.includes("partner-registration")
                ? !userData.can_create_competition &&
                  to.name == "create-competition"
                  ? next(redirectName)
                  : next()
                : to.fullPath == "/" || to.meta.redirectIfLoggedIn
                ? next(redirectName)
                : next("/404");
            } else {
              return to.fullPath.includes("plans")
                ? next()
                : next({ name: "plans" });
            }
          } else {
            if (userStatus.hasPlan) {
              return userStatus.hasDocument
                ? to.name == "partner-registration-step3"
                  ? next()
                  : next({ name: "partner-registration-step3" })
                : to.name == "partner-registration-step3" ||
                  to.name == "partner-registration-step2"
                ? next()
                : next({ name: "partner-registration-step2" });
            } else {
              return to.name == "partner-registration-step1"
                ? next()
                : next({ name: "partner-registration-step1" });
            }
          }
        } else if (userData.status == "REJECTED") {
          return to.name == "partner-registration-step3" ||
            to.name == "partner-registration-step2"
            ? next()
            : next({ name: "partner-registration-step2" });
        } else {
          return to.fullPath.includes(redirectName)
            ? next()
            : next({ name: redirectName });
        }
      }
      if (
        Object.keys(to.meta).findIndex((key) => key.includes(accountTypeCap)) ==
        -1
      ) {
        return next({ name: redirectName });
      }
    }
    if (!to.meta.redirectIfLoggedIn && !isLoggedIn && !to.meta.notNeedLogin) {
      return next({ name: "auth-user-login" });
    }
    return next();
  } catch (err) {}
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
